<kendo-grid
        [data]="tableGrid.gridData"
        [sortable]="true"
        [sort]="tableGrid.gridSort"
        (sortChange)="tableGrid.sortChange($event)"
        [selectable]="tableGrid.selectableSettings"
        [rowHeight]="tableGrid.options.rowHeight"
        [loading]="isLoading"
        [height]="rowHt - 70"
        [scrollable]="'virtual'">
    <kendo-grid-column title="Service" field="rsid"
                       [headerClass]="'ra-grid-header'"></kendo-grid-column>
    <kendo-grid-column title="Departure Date" field="effDt"
                       [headerClass]="'ra-grid-header'"></kendo-grid-column>
    <kendo-grid-column title="Repeated Station" field="station"
                       [headerClass]="'ra-grid-header'"></kendo-grid-column>
</kendo-grid>
